import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { NzTooltipModule } from 'ng-zorro-antd/tooltip';
import { HighchartsChartComponent } from 'highcharts-angular';
import { HelpIconBtnComponent } from '../components/help-icon-btn/help-icon-btn.component';
import { FormattedLabelComponent } from '../components/forms/formatted-label/formatted-label.component';
import {
  IonHeader,
  IonToolbar,
  IonButtons,
  IonButton,
  IonIcon,
  IonImg,
  IonSelect,
  IonSelectOption,
  IonContent,
  IonTitle,
  IonApp,
  IonRouterOutlet,
  IonInput,
  IonLabel,
  IonItem,
  IonList,
  IonSpinner,
  IonModal,
  IonSegment,
  IonSegmentButton,
} from '@ionic/angular/standalone';

const IONIC_COMPONENTS = [
  IonHeader,
  IonToolbar,
  IonButtons,
  IonButton,
  IonIcon,
  IonImg,
  IonSelect,
  IonSelectOption,
  IonContent,
  IonTitle,
  IonApp,
  IonRouterOutlet,
  IonInput,
  IonLabel,
  IonItem,
  IonList,
  IonSpinner,
  IonModal,
  IonSegment,
  IonSegmentButton,
];

const THIRD_PARTY_COMPONENTS = [HighchartsChartComponent];

const SHARED_COMPONENTS = [HelpIconBtnComponent, FormattedLabelComponent];

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    TranslateModule.forChild(),
    NzTooltipModule,
    ...IONIC_COMPONENTS,
    ...THIRD_PARTY_COMPONENTS,
    ...SHARED_COMPONENTS,
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    TranslateModule,
    NzTooltipModule,
    ...IONIC_COMPONENTS,
    ...THIRD_PARTY_COMPONENTS,
    ...SHARED_COMPONENTS,
  ],
})
export class SharedModule { }
